import React from 'react';
import { Columns, Column } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import ReactHtmlParser from 'react-html-parser';
import { useBeAmazingController } from './BeAmazing.controllers';
import {
  WrapperBox,
  BeAmazingBox,
  StyledCloudImage,
  OutlineArtBox,
  FillArtBox,
  TextWrapperBox,
  StyledText,
  NameStyledText,
} from './BeAmazing.styles';
import { BeAmazingContent } from './BeAmazingContent';
import { useTranslation } from 'react-i18next';

export const BeAmazingDesktop: React.FC = (props) => {
  const { containerRef, fillRef } = useBeAmazingController();

  const { t } = useTranslation('careers');
  const beAmazingData = t('beAmazing');

  return (
    <WrapperBox ref={containerRef}>
      <BeAmazingBox marginBottom={13} backgroundColor="neutra6">
        <StyledCloudImage src={'careers/quotes/1/pic.jpg'} height="100%" />
        <OutlineArtBox>
          <CloudImage src={'careers/quotes/1/outline-circle.svg'} width="100%" />
        </OutlineArtBox>
        <TextWrapperBox>
          <Columns>
            <Column width={'half'}>
              <StyledText color="neutra1" variant="hed40" tagName="h2">
                {ReactHtmlParser(beAmazingData.title)}
              </StyledText>
              <NameStyledText color="neutra1" variant="sectionEyeBrow24" tagName="p" marginTop={6}>
                {beAmazingData.name}
              </NameStyledText>
            </Column>
          </Columns>
        </TextWrapperBox>
      </BeAmazingBox>
      <FillArtBox ref={fillRef}>
        <CloudImage src={'careers/be-amazing/fill-circle.svg'} width="100%" />
      </FillArtBox>
      <BeAmazingContent />
    </WrapperBox>
  );
};
